import axios from "axios";
import { useCancelToken } from "hooks";
import _ from "lodash";
import { useCallback, useState } from "react";

const useLoadMaintenanceEvents = (httpRequest, { truckId = 0, maintenance = 0 }) => {
  const [isListLoading, setIsListLoading ] = useState(false);
  const [list, setList] = useState([]);
  const [errors, setErrors] = useState({});
  const { getCancelToken } = useCancelToken();

  const loadMaintenanceEvents = useCallback(async () => {
    setIsListLoading(true);
    const response = await httpRequest({
      method: 'get',
      url: `maintenance-events?truck_id=${truckId}&truck_maintenance_id=${maintenance}`,
      getCancelToken: getCancelToken(),
    })
    .catch((e) => {
      if (axios.isCancel(e)) setIsListLoading(true);
      else setErrors(e.response.data);
    })
    if (response) {
      const data = _.get(response, 'data.data', []);
      setList(data);
      setIsListLoading(false);
    }
  }, [httpRequest, truckId, maintenance, getCancelToken])

  return { list, isListLoading, setIsListLoading, loadMaintenanceEvents, errors, setList }
}

export default useLoadMaintenanceEvents